import { FC } from "react";

import { classname } from "@ctra/utils";
import { Col, Row, Skeleton } from "@ctra/components";

import {
  AjinomotoBloodTestInsight,
  InsightValidation,
  useInsight,
  AjinomotoBloodScreeningSchedule
} from "@insights";

import baseStyles from "../InsightBody/InsightBody.module.less";

/**
 * Insight body with blood test results/recommendations
 * @return {React.ReactNode}
 * @constructor
 */
export const AjinomotoBloodTestInsightBody: FC = () => {
  const {
    meta: { isLoading }
  } = useInsight<AjinomotoBloodTestInsight>();

  return (
    <Skeleton active loading={isLoading}>
      <Row className={classname(baseStyles.Row, baseStyles.Padded, baseStyles.Gray)}>
        <Col flex={1}>
          <AjinomotoBloodScreeningSchedule />
        </Col>
      </Row>
      <Row className={classname(baseStyles.Row, baseStyles.Padded, baseStyles.LastRow)}>
        <Col flex={1}>
          <InsightValidation />
        </Col>
      </Row>
    </Skeleton>
  );
};
